/* Leadway Digital — Theme JavaScript
   Custom cursor · Magnetic buttons · GSAP ScrollTrigger
   Lenis smooth scroll · FAQ accordion · Counters · Nav */

(function () {
  'use strict';

  /* ── Shopify editor detection ─────────────────────── */
  var IS_EDITOR = !!(window.Shopify && window.Shopify.designMode);
  if (IS_EDITOR) {
    document.documentElement.classList.add('shopify-editor-mode');
  }

  /* ── Shared Lenis reference ───────────────────────── */
  var _lenis = null;

  /* ── Anchor scroll helper ─────────────────────────── */
  function getHashTarget(href) {
    if (!href) return null;
    var hashIdx = href.indexOf('#');
    if (hashIdx === -1) return null;
    var hash = href.slice(hashIdx + 1);
    if (!hash) return null;
    return document.getElementById(hash);
  }

  function scrollToEl(el) {
    if (!el) return;
    if (_lenis) {
      _lenis.scrollTo(el, { offset: -80, duration: 1.2 });
    } else {
      var top = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  /* ── Anchor link interception — registered IMMEDIATELY ─
     Runs before DOMContentLoaded so every click is caught
     regardless of whether Lenis/GSAP finish loading.      */
  document.addEventListener('click', function (e) {
    var anchor = e.target.closest('a[href]');
    if (!anchor) return;
    var href = anchor.getAttribute('href');
    if (!href) return;
    var isHashOnly = href.charAt(0) === '#';
    var isRootHash = href.charAt(0) === '/' && href.charAt(1) === '#';
    if (!isHashOnly && !isRootHash) return;
    var target = getHashTarget(href);
    if (!target) return;
    e.preventDefault();
    scrollToEl(target);
    if (!IS_EDITOR) {
      var hash = href.slice(href.indexOf('#'));
      try { history.pushState(null, '', hash); } catch (err) {}
    }
  }, false);

  /* ── Reveal all animated elements (editor only) ───── */
  function revealAll() {
    var sels = [
      '.hero-tag', '.hero-headline', '.hero-sub', '.hero-actions',
      '.hero-social-proof', '.hero-float-card', '.hero-scroll',
      '.service-card', '.why-feature', '.process-step',
      '.pricing-card', '.testimonial-card', '.faq-item',
      '.cta-eyebrow', '.cta-headline', '.cta-sub', '.cta-actions',
      '.service-detail-item', '.value-card', '.animate-in',
      '.page-hero h1', '.page-hero p'
    ].join(',');
    document.querySelectorAll(sels).forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  /* ── Smooth scroll (Lenis) ────────────────────────── */
  function initLenis() {
    if (typeof Lenis === 'undefined') return;
    _lenis = new Lenis({
      duration: 1.3,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      wheelMultiplier: 0.8
    });

    function raf(time) { _lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);

    if (typeof gsap !== 'undefined' && gsap.ticker) {
      gsap.ticker.add(function (time) { _lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
    }

    /* Scroll to hash target on initial page load */
    var initHash = window.location.hash;
    if (initHash) {
      var initTarget = document.querySelector(initHash);
      if (initTarget) {
        setTimeout(function () { scrollToEl(initTarget); }, 400);
      }
    }
  }

  /* ── Custom cursor ────────────────────────────────── */
  function initCursor() {
    var ring = document.getElementById('ld-cursor-ring');
    var dot  = document.getElementById('ld-cursor-dot');
    if (!ring || !dot) return;

    var rx = 0, ry = 0, dx = 0, dy = 0;
    var visible = false;

    document.addEventListener('mousemove', function (e) {
      dx = e.clientX; dy = e.clientY;
      if (!visible) { rx = dx; ry = dy; visible = true; ring.style.opacity = '1'; dot.style.opacity = '1'; }
    });
    document.documentElement.addEventListener('mouseleave', function () { ring.style.opacity = '0'; dot.style.opacity = '0'; });
    document.documentElement.addEventListener('mouseenter', function () { ring.style.opacity = '1'; dot.style.opacity = '1'; });

    document.addEventListener('mousedown', function () { document.body.classList.add('cursor-clicking'); });
    document.addEventListener('mouseup',   function () { document.body.classList.remove('cursor-clicking'); });

    document.addEventListener('mouseover', function (e) {
      var el = e.target.closest('a, button, [data-cursor], input, textarea, select, label, .btn-magnetic');
      if (el) document.body.classList.add('cursor-hovering');
      else     document.body.classList.remove('cursor-hovering');
    });

    function lerp(a, b, t) { return a + (b - a) * t; }
    var RING_LERP = 0.12;
    function tick() {
      rx = lerp(rx, dx, RING_LERP);
      ry = lerp(ry, dy, RING_LERP);
      ring.style.transform = 'translate(' + rx + 'px, ' + ry + 'px) translate(-50%, -50%)';
      dot.style.transform  = 'translate(' + dx + 'px, ' + dy + 'px) translate(-50%, -50%)';
      requestAnimationFrame(tick);
    }
    tick();
  }

  /* ── Navigation ───────────────────────────────────── */
  function initNav() {
    var header = document.getElementById('ld-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    }, { passive: true });

    var links = document.querySelectorAll('.nav-links a');
    var path = window.location.pathname;
    links.forEach(function (link) {
      if (link.getAttribute('href') === path) link.classList.add('active');
    });

    var hamburger = document.getElementById('nav-hamburger');
    var overlay   = document.getElementById('nav-mobile-overlay');
    if (!hamburger || !overlay) return;

    hamburger.addEventListener('click', function () {
      var open = overlay.classList.contains('open');
      overlay.classList.toggle('open');
      hamburger.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', String(!open));
      /* Never lock body scroll inside the Shopify editor — breaks editor layout */
      if (!IS_EDITOR) document.body.style.overflow = open ? '' : 'hidden';
    });

    overlay.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        overlay.classList.remove('open');
        hamburger.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        if (!IS_EDITOR) document.body.style.overflow = '';
      });
    });
  }

  /* ── Magnetic buttons ─────────────────────────────── */
  function initMagnetic() {
    document.querySelectorAll('.btn-magnetic').forEach(function (btn) {
      var bx = 0, by = 0, STRENGTH = 0.32;
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var ox = (e.clientX - rect.left - rect.width  / 2) * STRENGTH;
        var oy = (e.clientY - rect.top  - rect.height / 2) * STRENGTH;
        bx += (ox - bx) * 0.2;
        by += (oy - by) * 0.2;
        btn.style.transform = 'translate(' + bx + 'px, ' + by + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        bx = 0; by = 0;
        btn.style.transform = 'translate(0,0)';
      });
    });
  }

  /* ── GSAP ScrollTrigger animations ───────────────── */
  function initGSAP() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    /* Hero entrance */
    var heroTL = gsap.timeline({ delay: 0.1 });
    heroTL
      .to('.hero-tag',          { opacity: 1, y: 0, duration: .9, ease: 'power3.out' })
      .to('.hero-headline',     { opacity: 1, y: 0, duration: .9, ease: 'power3.out' }, '-=.6')
      .to('.hero-sub',          { opacity: 1, y: 0, duration: .8, ease: 'power3.out' }, '-=.6')
      .to('.hero-actions',      { opacity: 1, y: 0, duration: .8, ease: 'power3.out' }, '-=.5')
      .to('.hero-social-proof', { opacity: 1, y: 0, duration: .8, ease: 'power3.out' }, '-=.5')
      .to('.hero-float-card',   { opacity: 1, x: 0, duration: .8, stagger: .2, ease: 'power3.out' }, '-=.6')
      .to('.hero-scroll',       { opacity: 1, duration: .8 }, '-=.3');

    /* Scroll-triggered reveals */
    gsap.to('.service-card', {
      opacity: 1, y: 0, duration: .85, stagger: .1, ease: 'power3.out',
      scrollTrigger: { trigger: '.services-grid', start: 'top 78%' }
    });
    gsap.to('.why-feature', {
      opacity: 1, y: 0, duration: .8, stagger: .08, ease: 'power3.out',
      scrollTrigger: { trigger: '.why-features', start: 'top 78%' }
    });
    gsap.to('.process-step', {
      opacity: 1, x: 0, duration: .8, stagger: .12, ease: 'power3.out',
      scrollTrigger: { trigger: '.process-grid', start: 'top 75%' }
    });
    gsap.to('.pricing-card', {
      opacity: 1, y: 0, duration: .85, stagger: .1, ease: 'power3.out',
      scrollTrigger: { trigger: '.pricing-grid', start: 'top 75%' }
    });
    gsap.to('.testimonial-card', {
      opacity: 1, y: 0, duration: .85, stagger: .12, ease: 'power3.out',
      scrollTrigger: { trigger: '.testimonials-grid', start: 'top 78%' }
    });
    gsap.to('.faq-item', {
      opacity: 1, y: 0, duration: .7, stagger: .07, ease: 'power3.out',
      scrollTrigger: { trigger: '.faq-list', start: 'top 78%' }
    });

    /* Final CTA */
    var ctaTL = gsap.timeline({ scrollTrigger: { trigger: '#ld-final-cta', start: 'top 70%' } });
    ctaTL
      .to('.cta-eyebrow',  { opacity: 1, y: 0, duration: .8, ease: 'power3.out' })
      .to('.cta-headline', { opacity: 1, y: 0, duration: .9, ease: 'power3.out' }, '-=.5')
      .to('.cta-sub',      { opacity: 1, y: 0, duration: .8, ease: 'power3.out' }, '-=.5')
      .to('.cta-actions',  { opacity: 1, y: 0, duration: .8, ease: 'power3.out' }, '-=.4');

    /* Page hero */
    var pageHeroH = document.querySelector('.page-hero h1');
    var pageHeroP = document.querySelector('.page-hero p');
    if (pageHeroH) gsap.to(pageHeroH, { opacity: 1, y: 0, duration: .9, delay: .1, ease: 'power3.out' });
    if (pageHeroP) gsap.to(pageHeroP, { opacity: 1, y: 0, duration: .8, delay: .25, ease: 'power3.out' });

    /* Misc animated elements */
    gsap.utils.toArray('.service-detail-item').forEach(function (el) {
      gsap.to(el, { opacity: 1, y: 0, duration: 1, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 75%' } });
    });
    gsap.to('.value-card', {
      opacity: 1, y: 0, duration: .8, stagger: .08, ease: 'power3.out',
      scrollTrigger: { trigger: '.values-grid', start: 'top 78%' }
    });
    gsap.utils.toArray('.animate-in').forEach(function (el) {
      gsap.from(el, { opacity: 0, y: 40, duration: .9, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 78%' } });
    });
  }

  /* ── Animated counters ────────────────────────────── */
  function initCounters() {
    var counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.dataset.counter);
        var decimals = el.dataset.decimals ? parseInt(el.dataset.decimals) : 0;
        var duration = 2200;
        var start = Date.now();
        var timer = setInterval(function () {
          var elapsed = Date.now() - start;
          var progress = Math.min(elapsed / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = eased * target;
          el.textContent = decimals ? value.toFixed(decimals) : Math.floor(value);
          if (progress === 1) { clearInterval(timer); el.textContent = decimals ? target.toFixed(decimals) : target; }
        }, 16);
        observer.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(function (c) { observer.observe(c); });
  }

  /* ── FAQ accordion ────────────────────────────────── */
  function initFAQ() {
    document.querySelectorAll('.faq-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        var wasOpen = item.classList.contains('open');
        document.querySelectorAll('.faq-item.open').forEach(function (i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });
  }

  /* ── Service chip selector ────────────────────────── */
  function initChips() {
    /* Visual state handled by CSS :checked */
    document.querySelectorAll('.service-chips input').forEach(function (input) {
      input.addEventListener('change', function () {});
    });
  }

  /* ── Contact form submit state ────────────────────── */
  function initContactForm() {
    /* ID matches the form in contact-section.liquid */
    var form = document.getElementById('ld-home-contact-form');
    if (!form) return;
    form.addEventListener('submit', function () {
      var btn = form.querySelector('.form-submit');
      if (btn) {
        btn.disabled = true;
        btn.querySelector('.form-submit-inner').innerHTML =
          '<svg style="width:18px;height:18px;animation:spin .8s linear infinite" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10" stroke-opacity=".25"/><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"/></svg> Sending...';
      }
    });
  }

  /* ── Spin keyframe for loader ─────────────────────── */
  (function () {
    var style = document.createElement('style');
    style.textContent = '@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }';
    document.head.appendChild(style);
  })();

  /* ── Boot ─────────────────────────────────────────── */
  function boot() {
    if (IS_EDITOR) {
      /*
       * Inside the Shopify theme editor:
       * - Skip Lenis (intercepts scroll/hash → "unsupported URL" error)
       * - Skip custom cursor and magnetic effects
       * - Skip GSAP ScrollTrigger (conflicts with editor scroll)
       * - Reveal all opacity:0 elements immediately
       * - Anchor link click handler already registered at module load
       */
      revealAll();
      initNav();
      initFAQ();
      initChips();
      return;
    }

    /* Live site — full experience */
    initLenis(); /* Sets _lenis — anchor click handler already registered, will use Lenis now */
    initCursor();
    initNav();
    initMagnetic();
    initGSAP();
    initCounters();
    initFAQ();
    initChips();
    initContactForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
